"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _QuestionEntityRecord = _interopRequireDefault(require("../QuestionEntityRecord"));

var _PropertyOptionButtons = _interopRequireDefault(require("./PropertyOptionButtons"));

var _PropertyTextInput = _interopRequireDefault(require("./PropertyTextInput"));

var _PropertyNumberInput = _interopRequireDefault(require("./PropertyNumberInput"));

var NullComponent = function NullComponent() {
  return null;
};

var PropertyQuickReplyInput = function PropertyQuickReplyInput(_ref) {
  var disabled = _ref.disabled,
      objectProperty = _ref.objectProperty,
      onChange = _ref.onChange,
      question = _ref.question;
  var PropertyInput = NullComponent;

  switch (question.propertyFieldType) {
    case 'radio':
    case 'select':
    case 'checkbox':
    case 'booleancheckbox':
      PropertyInput = _PropertyOptionButtons.default;
      break;

    case 'textarea':
    case 'text':
      PropertyInput = _PropertyTextInput.default;
      break;

    case 'number':
      PropertyInput = _PropertyNumberInput.default;
      break;

    default:
      console.error('Unsupported quick reply property field type');
  }

  return _react.default.createElement(PropertyInput, {
    question: question,
    objectProperty: objectProperty,
    disabled: disabled,
    onChange: onChange
  });
};

PropertyQuickReplyInput.propTypes = {
  onChange: _react.PropTypes.func,
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  objectProperty: _react.PropTypes.instanceOf(_immutable.Map).isRequired
};
PropertyQuickReplyInput.defaultProps = {
  onChange: function onChange() {
    return null;
  }
};
var _default = PropertyQuickReplyInput;
exports.default = _default;
module.exports = exports.default;